var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanternB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140.98 490.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fbca00;\n      }\n\n      .cls-2 {\n        isolation: isolate;\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: #3b0000;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-4 {\n        fill: #880404;\n      }\n\n      .cls-5 {\n        fill: #3b0000;\n      }\n\n      .cls-6 {\n        fill: #ffa617;\n      }\n\n      .cls-7 {\n        fill: #fff;\n        mix-blend-mode: soft-light;\n        opacity: .5;\n      }\n\n      .cls-8 {\n        fill: #fbe394;\n        mix-blend-mode: multiply;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u5716\\u5C64_2",
    "data-name": "\\u5716\\u5C64 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u5716\\u5C64_1-2",
    "data-name": "\\u5716\\u5C64 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 72.78,
    y1: 145.43,
    x2: 72.78,
    y2: 461.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M82.14,435.99c0,5.17-4.19,9.36-9.36,9.36s-9.36-4.19-9.36-9.36,4.19-9.36,9.36-9.36,9.36,4.19,9.36,9.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.55,486.53c-3.15-3-5.4-6.99-6.81-11.1-1.51-4.4-1.88-9.12-3.31-13.55l-13.8.29c-.77,9.05-2.77,18-5.91,26.52,3.61.95,7.29,1.49,11.03,1.67.11-.67.21-1.35.32-2.02.05.64.1,1.28.15,1.92,4.38.23,8.93-.1,13.23-.94-.17-1.26-.39-2.54-.56-3.8.65.85,1.3,1.71,1.94,2.56,1.23-.52,2.49-1.03,3.72-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M72.54,454.96c-4.49,0-8.12,3.64-8.12,8.12h16.25c0-4.49-3.64-8.12-8.12-8.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.05,410.57h67.46c3.87,0,7.01-3.14,7.01-7.01v-17.28H32.04v17.28c0,3.87,3.14,7.01,7.01,7.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M106.13,203.78H39.43c-3.83,0-6.93,3.1-6.93,6.93v17.09h80.56v-17.09c0-3.83-3.1-6.93-6.93-6.93Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "140.98 238.2 0 238.2 6.07 221.17 134.92 221.17 140.98 238.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "140.98 238.2 0 238.2 6.07 255.24 134.92 255.24 140.98 238.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "140.98 272.27 0 272.27 6.07 255.24 134.92 255.24 140.98 272.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "140.98 272.27 0 272.27 6.07 289.3 134.92 289.3 140.98 272.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "140.98 306.33 0 306.33 6.07 289.3 134.92 289.3 140.98 306.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "140.98 306.33 0 306.33 6.07 323.36 134.92 323.36 140.98 306.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "140.98 340.39 0 340.39 6.07 323.36 134.92 323.36 140.98 340.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "140.98 340.39 0 340.39 6.07 357.42 134.92 357.42 140.98 340.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "140.98 374.45 0 374.45 6.07 357.42 134.92 357.42 140.98 374.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "140.98 374.45 0 374.45 6.07 391.48 134.92 391.48 140.98 374.45"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "134.92 255.24 140.98 238.2 134.92 221.17 90.52 221.17 96.58 238.2 90.52 255.24 96.58 272.27 90.52 289.3 96.58 306.33 90.52 323.36 96.58 340.39 90.52 357.42 96.58 374.45 90.52 391.48 134.92 391.48 140.98 374.45 134.92 357.42 140.98 340.39 134.92 323.36 140.98 306.33 134.92 289.3 140.98 272.27 134.92 255.24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 36.96,
    cy: 275.98,
    rx: 23.54,
    ry: 43.26
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 72.79,
    y1: 109.76,
    x2: 72.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 72.88,
    cy: 159.39,
    r: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M82.38,80.56c0,5.52-4.48,10-10,10s-10-4.48-10-10,4.48-10,10-10,10,4.48,10,10Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 72.59,
    cy: 128.12,
    r: 9.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 72.59,
    cy: 128.12,
    r: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90.27,128.12c0,3.44-2.78,6.22-6.22,6.22s-6.22-2.78-6.22-6.22,2.78-6.22,6.22-6.22,6.22,2.78,6.22,6.22Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 61.49,
    cy: 128.12,
    r: 6.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72.77,110.62c3.44,0,6.22,2.78,6.22,6.22s-2.78,6.22-6.22,6.22-6.22-2.78-6.22-6.22,2.78-6.22,6.22-6.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72.77,145.62c3.44,0,6.22-2.78,6.22-6.22s-2.78-6.22-6.22-6.22-6.22,2.78-6.22,6.22,2.78,6.22,6.22,6.22Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanternB);
export default __webpack_public_path__ + "static/media/lanternB.b884d86f94db32e266f0a3429fd119e8.svg";
export { ForwardRef as ReactComponent };